import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import ListSubheader from "@material-ui/core/ListSubheader";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Delete";
import Add from "@material-ui/icons/AddAPhoto";
import fire from "../config/Fire";
import SweetAlert from "sweetalert2-react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper
  },
  gridList: {
    width: 325,
    height: 350
  },
  icon: {
    color: "rgba(214, 69, 65, 1)"
  },
  add: {
    color: "rgba(86, 86, 86, 1)"
  }
});
function Transition(props) {
  return <Slide direction="up" {...props} />;
}
class album extends React.Component {
  constructor(props) {
    super(props);
    this.handleUploadAR = this.handleUploadAR.bind(this);
    this.eliminarAlbum = this.eliminarAlbum.bind(this);
    this.eliminarFoto = this.eliminarFoto.bind(this);
    this.titulo = props.titulo;
    this.state = {
      pictures: [],
      show: false,
      open: false,
      imagen: null,
      uploadValue: 0,
      titulo1: null,
      titulo: ""
    };
  }
  componentDidMount() {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        fire
          .database()
          .ref()
          .child("Album")
          .child(this.titulo)
          .on("child_added", snapshot => {
            this.setState({
              pictures: this.state.pictures.concat(snapshot.val())
            });
          });
        //Separo fecha y ciudad
        var titulocompleto = this.titulo.split("-");
        //Separo el título del día
        var ultimo = titulocompleto[0].split(" ");
        //Guardo el día
        var dia = ultimo[ultimo.length - 1];
        //Creo la fecha
        var fecha = dia + "/" + titulocompleto[1] + "/" + titulocompleto[2];
        //Tengo la ciudad
        var ciudad = titulocompleto[3];
        //Creo el título
        var titulo = "";
        for (var i = 0; i < ultimo.length - 1; i++) titulo += ultimo[i] + " ";
        //Verifico que se vea bien
        if (titulo.length >= 25)
          this.setState({ titulo: titulo.substring(0, 25) + "..." });
        else this.setState({ titulo: titulo });
      }
    });
  }

  eliminar() {
    this.setState({ show: false });

    if (this.state.confirmacion === "Eliminar imagen") {
      this.eliminarFoto();
    } else {
      this.eliminarAlbum();
    }
  }
  eliminarAlbum() {
    this.state.pictures.map(key => {
      const storageRefImg = fire
        .storage()
        .ref(`/Album/${this.titulo}/${key.name}`);
      storageRefImg.delete();
    });
    fire
      .database()
      .ref()
      .child("Album")
      .child(this.titulo)
      .remove();
  }
  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };
  eliminarFoto() {
    fire.auth().onAuthStateChanged(user => {
      if (user) {
        var nombre = this.state.nombre;
        var titulo = this.titulo;
        const storageRefImg = fire
          .storage()
          .ref(`/Album/${this.titulo}/${nombre}`);
        storageRefImg
          .delete()
          .then(function() {
            fire
              .database()
              .ref()
              .child("Album")
              .child(titulo)
              .orderByChild("name")
              .equalTo(nombre)
              .on("child_added", snapshot => {
                fire
                  .database()
                  .ref()
                  .child("Album")
                  .child(titulo)
                  .child(snapshot.key)
                  .remove();
              });
            window.location.reload();
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    });
  }
  agregarFoto() {}
  confirmarEliminacion(confirmacion, nombre) {
    this.setState({ show: true, confirmacion: confirmacion, nombre: nombre });
  }
  handleClose = () => {
    this.setState({
      open: false,
      titulo: "",
      imagen: null,
      uploadValue: 0
    });
  };
  handleUploadAR(event) {
    const file = event.target.files[0];
    this.setState({ imagen: file });
  }
  handleNew = () => {
    if (this.state.imagen !== null) {
      var titulo = this.titulo;
      var name = this.state.imagen.name;
      const storageRef = fire
        .storage()
        .ref(`/Album/${this.titulo}/${this.state.imagen.name}`);
      const task = storageRef.put(this.state.imagen);
      task.on(
        "state_changed",
        snapshot => {
          let percentage =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.setState({
            uploadValue: percentage
          });
        },
        error => {},
        () => {
          storageRef.getDownloadURL().then(url => {
            fire
              .database()
              .ref()
              .child("Album")
              .child(titulo)
              .push()
              .set({ name: name, link: url });
          });
        }
      );
    } else {
      alert("Debes ingresar contenido para el album");
    }
  };
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <GridList cellHeight={180} className={classes.gridList}>
          <GridListTile key="Subheader" cols={6} style={{ height: "auto" }}>
            <ListSubheader component="div">
              {this.state.titulo}
              <IconButton
                className={classes.add}
                onClick={this.handleClickOpen}
              >
                <Add />
              </IconButton>
              <IconButton
                className={classes.add}
                onClick={() =>
                  this.confirmarEliminacion("Eliminar album", this.titulo)
                }
              >
                <InfoIcon />
              </IconButton>
            </ListSubheader>
          </GridListTile>
          {this.state.pictures.map(tile => (
            <GridListTile key={tile.link}>
              <img src={tile.link} alt={tile.name} />
              <GridListTileBar
                title={tile.name}
                //subtitle={<span>by: {tile.author}</span>}
                actionIcon={
                  <IconButton
                    className={classes.icon}
                    onClick={() =>
                      this.confirmarEliminacion("Eliminar imagen", tile.name)
                    }
                  >
                    <InfoIcon />
                  </IconButton>
                }
              />
            </GridListTile>
          ))}
        </GridList>
        <Dialog
          open={this.state.open}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {"Agregar foto a: " + this.titulo}
          </DialogTitle>
          <DialogContent>
            <div>
              <progress value={this.state.uploadValue} max="100" />
              <br />
              <input
                accept="image/*"
                type="file"
                disableUnderline={true}
                name="Imagen"
                onChange={this.handleUploadAR}
              />
              <br />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancelar
            </Button>
            <Button onClick={this.handleNew} color="primary">
              Crear album
            </Button>
          </DialogActions>
        </Dialog>
        <SweetAlert
          show={this.state.show}
          title="¿Estás seguro?"
          text="No podrás revertir los cambios"
          type="warning"
          showCancelButton="true"
          confirmButtonColor="#3085d6"
          cancelButtonColor="#d33"
          cancelButtonText="Cancelar"
          confirmButtonText={this.state.confirmacion}
          onConfirm={() => this.eliminar()}
        />
      </div>
    );
  }
}
album.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(album);
